import React, {useState} from 'react';
import Navigation from './Navigation'
import { Router } from '@reach/router'
import { auth } from '../firebase'
//pages below
import Home from './Home'
import AllOrders from './AllOrders'
import AboutUs from './AboutUs'
import SignIn from './SignIn'
import UpdatePost from './UpdatePost'
import CreateRequest from './CreateRequest'
import ArtsStatus from './ArtsStatus'
import CommerceStatus from './CommerceStatus'
import ArtsForm from './ArtsForm'
import CommerceForm from './CommerceForm'

function App(props){

    const [user, setUser] = useState(false)

    auth.onAuthStateChanged(function(user) {
        if (user) {
          // User is signed in.
            setUser(user)
        } else {
          // No user is signed in.
          setUser(false)
        }
      });


    return(
        <div className="app_container" style={{minHeight:"100%"}}>
        
            <Navigation user={user}/>
            
            <Router>
                <Home path="Home" default />
                <AllOrders path="AllOrders" user={user} />
                <CreateRequest path="CreateRequest/:clg" />
                <ArtsForm path="ArtsForm" />
                <CommerceForm path="CommerceForm" />
                <ArtsStatus path="ArtsStatus/:id" />
                <CommerceStatus path="CommerceStatus/:id" />
                <UpdatePost path="update_post/:id" />
                <AboutUs path="AboutUs" />
                <SignIn path="SignIn" />
            </Router>
        </div>       
    )
}

export default App;